import { PHASE_PRODUCTION_BUILD } from "next/constants";

function logoAssetUrl(asset: unknown): string | undefined {
  if (typeof asset === "string") return asset;
  if (typeof asset === "object" && asset !== null && "default" in asset && typeof asset.default === "string") {
    return asset.default;
  }
  return undefined;
}

const building = process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD;

const LOGO_ASSET_URLS = new Map<string, string>();
for (const [path, asset] of Object.entries(
  import.meta.glob(["./*.{png,webp,svg,jpeg}", "!./REVIEW*", "!./id*"], {
    base: "../public/images/sportsbooks",
    eager: true,
    query: "?url",
  }),
)) {
  const url = logoAssetUrl(asset);
  if (url === undefined) {
    if (building) throw new Error(`Unexpected sportsbook logo asset for ${path}: ${JSON.stringify(asset)}`);
    continue;
  }
  LOGO_ASSET_URLS.set(path.slice(path.lastIndexOf("/") + 1), url);
}

if (LOGO_ASSET_URLS.size === 0 && building) {
  throw new Error("No sportsbook logos were bundled from public/images/sportsbooks");
}

export function sportsbookLogoUrl(filename: string): string {
  return LOGO_ASSET_URLS.get(filename) ?? `/images/sportsbooks/${filename}`;
}
